export default "__VITE_ASSET__BrECaDQk__"